export default {"src":"/login-app/[GIT_HASH]/_next/static/media/pending_actions.3ec3cd51.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};